import { useEffect } from 'react';
import { useInlineFieldEditingHoverStyles, useRegisterInlineFieldEditor } from '../lib/InlineFieldEditingHooks';
import { updateImageDom } from '../lib/domUtils/imageDomUtils';
export default function ImageFieldEditor({
  node,
  currentValue,
  moduleName
}) {
  useInlineFieldEditingHoverStyles(node);
  useRegisterInlineFieldEditor(moduleName);
  useEffect(() => {
    updateImageDom(node, currentValue);
  }, [currentValue, node]);
  return null;
}